export const STORE_PAGE_TEMPLATES = [
    {
        key: 'about',
        title: 'Sobre nós',
        slug: 'sobre',
        description: 'A história da loja e o que a torna diferente.',
        sections: [
            {
                type: 'rich-text',
                settings: {
                    title: 'Sobre nós',
                    text: '<p>Conte aqui como a loja começou, o que vocês fazem e por que os clientes escolhem vocês.</p>' +
                        '<p>Fale do cuidado com cada pedido, de quem está por trás do atendimento e do que vem por aí.</p>',
                },
            },
        ],
    },
    {
        key: 'contact',
        title: 'Contato',
        slug: 'contato',
        description: 'Telefone, WhatsApp, e-mail, endereço e horário.',
        sections: [
            {
                type: 'rich-text',
                settings: {
                    title: 'Fale com a gente',
                    text: '<p><strong>WhatsApp:</strong> (00) 00000-0000</p>' +
                        '<p><strong>E-mail:</strong> contato@sualoja.com.br</p>' +
                        '<p><strong>Endereço:</strong> Rua Exemplo, 123, Centro</p>' +
                        '<p><strong>Horário:</strong> segunda a sexta, das 9h às 18h</p>',
                },
            },
        ],
    },
    {
        key: 'returns',
        title: 'Trocas e devoluções',
        slug: 'trocas-e-devolucoes',
        description: 'Prazos e como pedir troca ou devolução.',
        sections: [
            {
                type: 'rich-text',
                settings: {
                    title: 'Trocas e devoluções',
                    text: '<p>Pelo Código de Defesa do Consumidor, compras feitas pela internet podem ser devolvidas em até 7 dias corridos após o recebimento.</p>' +
                        '<h3>Como pedir</h3><ul><li>Entre em contato informando o número do pedido.</li><li>Envie o produto sem sinais de uso, na embalagem original.</li><li>O reembolso sai pela mesma forma de pagamento.</li></ul>',
                },
            },
        ],
    },
    {
        key: 'privacy',
        title: 'Política de privacidade',
        slug: 'privacidade',
        description: 'Como os dados dos clientes são usados (LGPD).',
        sections: [
            {
                type: 'rich-text',
                settings: {
                    title: 'Política de privacidade',
                    text: '<p>Usamos seus dados apenas para processar pedidos, entregar compras e falar com você sobre elas.</p>' +
                        '<p>Você pode pedir a qualquer momento a correção ou a exclusão dos seus dados, nos termos da Lei Geral de Proteção de Dados (LGPD).</p>',
                },
            },
        ],
    },
    {
        key: 'blank',
        title: 'Página em branco',
        slug: 'nova-pagina',
        description: 'Comece do zero.',
        sections: [{ type: 'rich-text', settings: {} }],
    },
];
/** Endereço válido de página: minúsculas, números e hífen. */
export const STORE_PAGE_SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
/**
 * Endereços que a página não pode usar: a página fica na raiz da loja
 * (`/trocas-e-devolucoes`), e estes são rotas da própria vitrine, de hoje ou das
 * próximas etapas. Rota nova na vitrine entra aqui também.
 */
export const STORE_PAGE_RESERVED_SLUGS = [
    'account', 'api', 'c', 'cart', 'carrinho', 'category', 'categoria', 'checkout',
    'colecao', 'colecoes', 'collection', 'collections', 'conta', 'favicon', 'login', 'newsletter', 'p', 'pagina',
    'paginas', 'pages', 'pedido', 'pedidos', 'produto', 'produtos', 'robots',
    'search', 'busca', 'sitemap', 'static', 'themes', 'w',
];
export function isReservedStorePageSlug(slug) {
    return STORE_PAGE_RESERVED_SLUGS.includes(slug) || slug.startsWith('_');
}
/** Converte um título em endereço (`Trocas e Devoluções` -> `trocas-e-devolucoes`). */
export function slugifyStorePage(text) {
    return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60);
}
//# sourceMappingURL=page-templates.js.map